import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '../constants/constants';

@Pipe({
  name: 'roleBackground',
  standalone: false,
  pure: true
})
export class RoleBackgroundPipe implements PipeTransform {
  constructor() {}

  transform(role: UserRole): string {
    const onlineStatus = 'online';

    console.log("userrole", role, UserRole.TechnicianMobile);
    var userRoleLower = role == UserRole.TechnicianMobile || role == UserRole.TechnicianGlass || role == UserRole.TechnicianNoApp ? 'technician' : 'expert';

    const imageName = 'background-' + userRoleLower + '-' + onlineStatus + '.svg';
    const imagePath = 'assets/images/users/' + imageName;
    return imagePath;
  }
}
